<template>
    <div class="event-log-viewer">
        <div class="datagrid-wrapper">
            <div class="row">
                <div class="col-md-12">
                    <h2>{{ title || 'Events' }}</h2>
                    <div class="sub-grid-buttons" v-if="seeAllLink">
                        <a @click="fetch()" class="btn btn-light">Refresh</a>
                        <a id="show-all" class="btn btn-link" :href="seeAllLink">See all</a>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-md-12" data-type="grid">
                    <table class="datagrid table">
                        <thead>
                        <tr>
                            <th><h4>Centre</h4></th>
                            <th><h4>Event</h4></th>
                            <th><h4>Lock</h4></th>
                            <th><h4>User</h4></th>
                            <th><h4>Date</h4></th>
                            <th><h4>Time</h4></th>
                        </tr>
                        </thead>
                        <tbody>
                            <tr v-if="isLoading">
                                <td colspan="6">
                                    <div class="loading-events"><span class="spinner anim-spin"></span></div>
                                </td>
                            </tr>
                            <template v-if="!isLoading">
                                <tr v-for="event in events">
                                    <td>{{ event.centre.name }}</td>
                                    <td>
                                        {{ event.event.description }}
                                        <small v-if="event.event.access_by_description">&nbsp;
                                            {{ event.event.access_by_description }}</small>
                                    </td>
                                    <td>
                                        <span v-if="event.lock">{{ event.lock.description }}</span>
                                        <span v-if="event.lock && event.lock.name"> - {{ event.lock.name }}</span>
                                    </td>
                                    <td><span v-if="event.user">{{ event.user.name }} <template v-if="event.user.deleted_at">(deleted)</template></span></td>
                                    <td>{{ $formatDate(event.date, dateFormat) }}</td>
                                    <td>{{ event.time }}</td>
                                </tr>
                            </template>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped>
.event-log-viewer {
    padding: 20px 0;
}
</style>
<script>
import Events from "../Services/Events";

export default {

    props: ['max', 'title', 'seeAllLink', 'centreId', 'companyId', 'userId', 'lockId', 'inventoryId', 'dateFormat'],

    data: () => {
        return {
            events: [],
            filters: {},
            isLoading: false,
            visible: false,
        }
    },

    mounted: function () {

        if (!this.type) {
            this.type = "entries";
        }

        if (this.centreId) this.filters.centre_id = this.centreId;
        if (this.userId) this.filters.user_id = this.userId;
        if (this.companyId) this.filters.company_id = this.companyId;
        if (this.inventoryId) this.filters.inventory_id = this.inventoryId;
        if (this.lockId) this.filters.lock_id = this.lockId;

        this.fetch();
    },

    methods: {

        fetch: function () {

            this.isLoading = true;

            Events.getEvents(this.type, this.filters, this.max)
                .then((data) => {
                    this.isLoading = false;
                    this.events = data.events;
                })
                .catch((err) => {
                    this.isLoading = false;
                })
        },
    }
}
</script>
